import React, { Component } from "react";
import PropTypes from "prop-types";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import CalendarSponsorForm from "components/Calendar/Calendar";
import inputFormatter from "services/userInputFormatter";
import { connect } from "react-redux";
import actions from "actions/index";
import _ from "lodash";
import moment from "moment";
import { toast } from "react-toastify";
import EditCalendarSponsorForm from "components/Calendar/EditCalendarForm";

const { updateCalendarSaga, loadCalendarBooking } = actions;

class EditCalendarSponsor extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    createCalendarBooking: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);
    const startOfYear = moment().subtract(30, "days").format("YYYY/MM/DD");
    const endOfYear = moment().add(30, "days").format("YYYY/MM/DD");
    const period = `${startOfYear} - ${endOfYear}`;

    this.state = {
      startDate: null,
      endDate: null,
    };
    this.state = {
      termsOfService: false,
      booking: {
        webinar_title: "",
        user_id: "",
        location: "",
        accreditation: "",
        providing_speaker: "",
        sponsor: "",
        partnership: "",
        start_date: moment().set("seconds", 0),
        end_date: moment().set("seconds", 0),
        user_types: [0, 1, 2, 3, 4, 6, 7, 8],
        email: "",
        phone: "",
        contact_name: "Your Contact Name",
        comment: "",
        booking_experts_attributes: [
          {
            name: "",
            location: "",
            expert_type: "",
          },
        ],
      },
      period,
    };
    this.props.loadCalendarBookingSaga(
      this.props.location.pathname.split("/")[3]
    );
  }

  componentWillReceiveProps(props) {
    if (
      (props.booking && !_.isEqual(this.props.booking, props.booking)) ||
      (props.booking && !_.isEqual(this.state.booking, props.booking))
    ) {
      this.setState({
        booking: {
          ...this.state.booking,
          ...props.booking,
          booking_experts_attributes:
            props.booking.booking_experts ||
            this.state.booking.booking_experts_attributes,
          start_date: moment(props.booking.start_date),
          end_date: moment(props.booking.end_date),
        },
      });
    }
  }

  onFieldChange = (e) => {
    const fieldValue = [...e.target.value];
    let input = inputFormatter.formatField(e.target.name, e.target.value);

    const bookingData = {
      ...this.state.booking,
      ...{
        [e.target.name]: input,
      },
    };
    if (e.target.name === "user_types") {
      const ipnaMemberIndex = fieldValue.indexOf(8);

      if (ipnaMemberIndex > -1) {
        fieldValue[ipnaMemberIndex] = 8;
      }
    }
    this.setState({ booking: bookingData });
  };

  onBookingExpertsAttributesChange = (e, index) => {
    let input = inputFormatter.formatField(e.target.name, e.target.value);

    const bookingData = {
      ...this.state.booking,
    };

    bookingData.booking_experts_attributes[index][e.target.name] = input;
    this.setState({ booking: bookingData });
  };

  onAddExpert = () => {
    const bookingData = {
      ...this.state.booking,
    };

    bookingData.booking_experts_attributes.push({
      name: "",
      location: "",
      expert_type: "",
    });
    this.setState({ booking: bookingData });
  };

  onRemoveElement = (index) => {
    const bookingData = {
      ...this.state.booking,
    };

    bookingData.booking_experts_attributes.splice(index, 1);
    this.setState({ booking: bookingData });
  };

  onDateChange = (field, value) => {
    const booking = {
      ...this.state.booking,
      ...{
        [field]: value,
      },
    };
    this.setState({ booking });
  };

  onUserTypeChangeCalendar = (roles) => {
    const rolesValue = (roles || []).map((role) => role.value);

    this.onFieldChange({
      target: {
        name: "user_types",
        value: (roles || []).map((role) => role.value),
      },
    });

    // this.props.loadCalendarEvents(this.state.period, rolesValue);
  };

  onBookingChange = (e) => {
    const fieldValue = [...e.target.value];
    let input = inputFormatter.formatField(e.target.name, e.target.value);
    const bookingData = {
      ...this.state.booking,
      ...{
        [e.target.name]: input,
      },
    };
    this.setState({ booking: bookingData });
  };

  onAccreditationChange = (e) => {
    debugger;
    const accreditation = parseInt(e.target.value);

    this.onBookingChange({
      target: {
        name: "accreditation",
        value: accreditation,
      },
    });
  };

  onProvidingSpeakerChange = (e) => {
    const providing_speaker = e.target.value;
    this.onBookingChange({
      target: {
        name: "providing_speaker",
        value: providing_speaker === "true",
      },
    });
  };

  onTextAreaChange = (e) => {
    const comment = e.target.value;
    this.onBookingChange({
      target: {
        name: "comment",
        value: comment,
      },
    });
  };

  onTermsOfServiceChange = (status) => {
    this.setState({
      termsOfService: status,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.props.updateCalendar(this.state.booking);
  };

  onPeriodChange = ({ start, end }) => {
    if (!start || !end) {
      return;
    }

    const startPeriod = moment(start).format("YYYY/MM/DD");
    const endPeriod = moment(end).format("YYYY/MM/DD");
    const period = `${startPeriod} - ${endPeriod}`;

    this.setState({
      ...this.state.booking,
      period,
    });

    // this.props.loadCalendarEvents(period);
  };

  render() {
    const user = localStorage.user && JSON.parse(localStorage.user);
    const isAdmin = user && user.role === "admin";
    const isSponsor = user && user.user_type === "sponsor";
    const { errors, errorsFrontend } = this.props;
    return (
      <main className="site--width clearfix-c">
        <EditCalendarSponsorForm
          booking={this.state.booking}
          termsOfService={this.state.termsOfService}
          onTermsOfServiceChange={this.onTermsOfServiceChange}
          onUserTypeChangeCalendar={this.onUserTypeChangeCalendar}
          onDateChange={this.onDateChange}
          onFieldChange={this.onFieldChange}
          onBookingExpertsAttributesChange={
            this.onBookingExpertsAttributesChange
          }
          onAddExpert={this.onAddExpert}
          onRemoveElement={this.onRemoveElement}
          onTextAreaChange={this.onTextAreaChange}
          onBookingChange={this.onBookingChange}
          onAccreditationChange={this.onAccreditationChange}
          onProvidingSpeakerChange={this.onProvidingSpeakerChange}
          onPeriodChange={this.onPeriodChange}
          onSubmit={this.onSubmit}
          events={this.state.bookings}
          is_admin={isAdmin}
          is_sponsor={isSponsor}
          user={this.state.user}
        />
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  booking: state.bookings && state.bookings.editBooking,
});

const mapDispatchToProps = (dispatch) => ({
  loadCalendarBookingSaga: (id) => dispatch(loadCalendarBooking(id)),
  updateCalendar: (booking) => dispatch(updateCalendarSaga(booking)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditCalendarSponsor);



// WEBPACK FOOTER //
// ./src/containers/Calendar/EditCalendar.jsx